import React, { Component, useEffect, useState } from 'react';
import './historicodetalle.css';
import { Progress, Result } from 'antd';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Moment from 'react-moment';

const Historicodetalle = props => {
  const eleccion = props.eleccion;
  const [resultado, setresultado] = useState([]);
  const [votos, setvotos] = useState<number>();
  useEffect(() => {
    if (eleccion) {
      const orden = _.orderBy(eleccion.resultadoFinal, ['voto'], ['desc']);
      setresultado(orden);
      const votos = _.sumBy(eleccion.resultadoFinal, function (o) {
        return o.voto;
      });
      setvotos(votos);
    }
  }, [eleccion]);

  return (<>
    {eleccion ? <div>
      <h5>RESULTADO PROCESO DE ELECCIONES</h5>
      <p className='fw-light'>{eleccion.nombre.toUpperCase()} (Periodo: <Moment locale={'es'}
        format={'DD/MM/YYYY'}>{eleccion.periodoIni}</Moment>-<Moment
          locale={'es'} format={'DD/MM/YYYY'}>{eleccion.periodoFin}</Moment>)</p>
      <table className='table'>
        <thead>
          <tr>
            <th scope='col' style={{ 'width': 50 }} />
            <th scope='col'>Total Votos Emitidos</th>
            <th scope='col' style={{ 'width': 250 }} />
            <th scope='col'>{votos}</th>
            <th scope='col' />
          </tr>
        </thead>
        <tbody>
          {
            resultado.map(x => {
              const v = parseFloat((x.voto / votos * 100).toFixed(1));
              return <tr>
                <th scope='row'>{x.numero}</th>
                <td>{x.nombres} {x.apellidos}</td>
                <td><Progress percent={v} status={'active'} /></td>
                <td>{x.voto}</td>
                <td><strong>{x.cargo}</strong></td>
              </tr>;
            })
          }
        </tbody>
      </table>
    </div> : <Result title={'Selecciones una elección'} />}
  </>);
};

Historicodetalle.propTypes =
{
  eleccion: PropTypes.object.isRequired
};

export default Historicodetalle;